import { createContext } from 'react';
import type { TabsProps } from './types';

export type TabsContext = Pick<TabsProps, 'dark' | 'fixedDropdownPosition' | 'mode' | 'size' | 'value'>;

export const TabsContext = createContext<TabsContext>({});
